"use client";
import { ConfigProvider, Menu, MenuProps } from "antd";
import React, { useEffect, useState } from "react";

import useMenuItem from "./hook";
import { usePathname } from "next/navigation";

interface MenuStructureProps {
  onClose: () => void;
  scrollY?: number;
  isDesktop?: boolean;
}

const MenuStructure = ({ onClose, scrollY, isDesktop = false }: MenuStructureProps) => {
  const pathname = usePathname();
  const [current, setCurrent] = useState(
    pathname === "/" ? "home" : pathname.replace("/", "")
  );
  const menuItems = useMenuItem();

  const onClick: MenuProps["onClick"] = (e) => {
    setCurrent(e.key);
    onClose();
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Sync menu selection with pathname changes
    setCurrent(pathname === "/" ? "home" : pathname.replace("/", ""));
  }, [pathname]);

  return (
    <>
      {isDesktop ? (
        <ConfigProvider
          theme={{
            components: {
              Menu: {
                itemColor:
                  scrollY !== 0 || pathname !== "/"
                    ? "var(--color-regal-black-light)"
                    : "var(--color-regal-white-light)",
                horizontalItemSelectedColor:
                  scrollY !== 0 || pathname !== "/" ? "#181C32" : "#FFFFFF",
                activeBarBorderWidth: "0",
                itemHoverColor:
                  scrollY !== 0 || pathname !== "/"
                    ? "var(--color-regal-black)"
                    : "#FFFFFF",
              },
            },
          }}
        >
          <Menu
            onClick={onClick}
            selectedKeys={[current]}
            mode="horizontal"
            items={menuItems}
            className="horizontalMenu"
            style={{
              backgroundColor: "transparent",
              fontSize: isDesktop ? "0.875rem" : "1rem",
              justifyContent: "start",
              fontWeight: 500,
              width: "calc(100% - 5rem)",
            }}
            rootClassName="horizontalMenu"
          />
        </ConfigProvider>
      ) : (
        <div className="flex flex-col justify-between h-[calc(100dvh-12.5rem)] verticalMenu">
          <Menu
            onClick={onClick}
            style={{
              width: "100%",
              overflow: "auto",
              direction: "rtl",
              textAlign: "start",
              borderInlineEnd: "none",
            }}
            className="verticalMenu"
            defaultSelectedKeys={[current]}
            defaultOpenKeys={[current]}
            selectedKeys={[current]}
            mode="inline"
            items={menuItems}
          />
        </div>
      )}
    </>
  );
};

export default MenuStructure;
